<template>
  <section class="ProfessionPageSectionCityTabs">
    <BlockHeading
      :title-level="2"
      :title="
        $t('professionalsPage.cities.title', {
          thePerson: profession.theperson.toLowerCase(),
        })
      "
    ></BlockHeading>
    <CityTabs :profession="profession" :city-person-count="cities" />
  </section>
</template>

<script>
import { inject } from "@nuxtjs/composition-api";
import CityTabs from "@/components/mainpage/CityTabs.vue";

export default {
  components: {
    CityTabs,
  },
  setup() {
    return {
      profession: inject("profession"),
      cities: inject("cities"),
    };
  },
};
</script>
